export default __webpack_public_path__ + "static/media/inde.a7103c1b.jpg";